import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { SelectButton } from "primereact/selectbutton";
import { EXERCISE_DEFAULTS } from "../../exerciseDefaults";

const ExerciseEditSection = ({
  t,
  selectedExercise,
  setSelectedExercise,
  isEditModeActive,
  editedExercises,
  setEditedExercises,
  setIsCollapsedDetails
}: any) => {
  const days = [{ name: t("Mon"), value: "Mon" }, { name: t("Tue"), value: "Tue" }, { name: t("Wed"), value: "Wed" }, { name: t("Thu"), value: "Thu" }, { name: t("Fri"), value: "Fri" }, { name: t("Sat"), value: "Sat" }, { name: t("Sun"), value: "Sun" }];
    
  const mergeEditedExercise = (updated: any) => {
    setEditedExercises((prev: any) => {
      const exists = prev.find(
        (x: any) => x.exercise.id === updated.exercise.id
      );

      if (exists) {
        return prev.map((x: any) =>
          x.exercise.id === updated.exercise.id ? updated : x
        );
      }

      return [...prev, updated];
    });
  };

  const handleDetailsChange = (value: number, name: string) => {
    if (!selectedExercise || value === undefined || value === null) return;

    let updated = { ...selectedExercise };

    if (name === "set" && value > 0) {
      updated = {
        ...updated,
        set: value,
        restInterval: Math.round(12 / value),
      };
    } else {
      updated = { ...updated, [name]: value };
    }

    setSelectedExercise(updated);

    if (isEditModeActive) {
      mergeEditedExercise(updated);
    }
  };

  const handleDaysChange = (e: any) => {
    const selectedDays = e.value || [];

    if(selectedDays.length === 0) return;

    const updated = { ...selectedExercise, days: e.value };
    setSelectedExercise(updated);

    if (isEditModeActive) {
      mergeEditedExercise(updated);
    }
  };

  const handleSetDefault = () => {
    setSelectedExercise({
      ...selectedExercise,
      set: EXERCISE_DEFAULTS.set,
      repeat: EXERCISE_DEFAULTS.repeat,
      tolerance: EXERCISE_DEFAULTS.tolerance,
      restInterval: Math.round(12 / EXERCISE_DEFAULTS.set),
      days: EXERCISE_DEFAULTS.days,
      isEveryOtherDay: false,
      everyOtherDayPeriod: 1,
    });
    if (isEditModeActive) {
      mergeEditedExercise({
        ...selectedExercise,
        set: EXERCISE_DEFAULTS.set,
        repeat: EXERCISE_DEFAULTS.repeat,
        tolerance: EXERCISE_DEFAULTS.tolerance,
        restInterval: Math.round(12 / EXERCISE_DEFAULTS.set),
        days: EXERCISE_DEFAULTS.days,
        isEveryOtherDay: false,
        everyOtherDayPeriod: 1,
      });
    }
  };

  const onAlternateDaysCheckedChange = (e: any) => {
    const updated = {
      ...selectedExercise,
      days: e.checked ? [] : EXERCISE_DEFAULTS.days,
      isEveryOtherDay: e.checked,
    };

    setSelectedExercise(updated);

    if (isEditModeActive) {
      mergeEditedExercise(updated);
    }
  };

  const handleApplyToAll = () => {
    if (!selectedExercise) return;
    const updatedExercises = editedExercises.map((ex: any) => ({
      ...ex,
      set: selectedExercise.set,
      repeat: selectedExercise.repeat,
      tolerance: selectedExercise.tolerance,
      restInterval: selectedExercise.restInterval,
      days: selectedExercise.days,
      isEveryOtherDay: selectedExercise.isEveryOtherDay,
      everyOtherDayPeriod: selectedExercise.everyOtherDayPeriod,
    }));
    setEditedExercises(updatedExercises);
  };

  return (
    <div className="flex flex-column gap-3 absolute bottom-0 w-full right-0 z-5 bg-white p-3">
      <div className="flex justify-content-between align-items-center">
        <span
          style={{
            color: "#727A99",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          className="text-2xl font-medium flex-1 mr-3"
          title={selectedExercise?.exercise?.name}
        >
          {selectedExercise?.exercise?.name}
        </span>
        <div className="flex gap-3 align-items-center">
          <Button
            style={{ borderRadius: "10px", height: "3rem" }}
            link
            className="p-0"
            onClick={handleApplyToAll}
          >
            <span
              className="flex justify-content-center align-items-center gap-2 font-semibold"
              style={{
                borderBottom: "1px solid rgba(99, 131, 244, 1)",
                width: "100%",
                color: "rgba(99, 131, 244, 1)",
                fontSize: "1rem",
              }}
            >
              <i className="pi pi-save"></i>
              {t("applyToAll")}
            </span>
          </Button>
          <Button
            style={{
              backgroundColor: "rgba(234, 235, 240, 1)",
              border: "none",
              borderRadius: "10px",
              height: "3rem",
              color: "rgba(87, 97, 133, 1)",
            }}
            onClick={handleSetDefault}
            disabled={!selectedExercise}
          >
            <span
              className="flex justify-content-center align-items-center gap-2 font-bold"
              style={{ width: "100%" }}
            >
              <img src="/set-default.svg" />
              {t("getDefault")}
            </span>
          </Button>
          <Button
            style={{
              backgroundColor: "rgba(234, 235, 240, 1)",
              border: "none",
              borderRadius: "10px",
              height: "3rem",
              color: "rgba(87, 97, 133, 1)",
            }}
            onClick={() => setIsCollapsedDetails(false)}
            disabled={!selectedExercise}
          >
            <span
              className="flex justify-content-center align-items-center gap-2 font-bold"
              style={{ width: "100%" }}
            >
              <i className="pi pi-times text-3xl"></i>
            </span>
          </Button>
        </div>
      </div>
      <div className="flex flex-column gap-3 overflow-y-auto overflow-x-hidden">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <div className="overflow-x-auto flex flex-column gap-2">
            <label htmlFor="set" style={{ color: "#727A99" }}>
              {t("days")} <span style={{ color: "#E3506B" }}>*</span>
            </label>
            <SelectButton
              disabled={selectedExercise?.isEveryOtherDay}
              className="days-select-button flex gap-3"
              value={selectedExercise.days}
              options={days}
              optionLabel="name"
              multiple
              onChange={handleDaysChange}
            />
          </div>

          <div className="flex flex-column gap-2 justify-content-center">
            <div className="flex align-items-center gap-2">
              <Checkbox
                name="label"
                onChange={onAlternateDaysCheckedChange}
                checked={selectedExercise?.isEveryOtherDay}
                disabled={!selectedExercise}
              />
              <label htmlFor="label" style={{ color: "#727A99" }}>
                {t("onAlternateDays")}
              </label>
            </div>
            <InputNumber
              value={selectedExercise?.everyOtherDayPeriod}
              disabled
              className="w-full add-exercise-dialog-input-number"
            />
          </div>

          <div
            className="flex flex-wrap align-items-center gap-2 p-3 border-round-2xl"
            style={{
              fontSize: "16px",
              color: "rgba(87, 97, 133, 1)",
              backgroundColor: "rgba(234, 235, 240, 1)",
            }}
          >
            <span>{t("dailyFrequency")}</span>
            <InputNumber
              min={1}
              max={75}
              invalid={!!selectedExercise && selectedExercise?.set === null}
              className="add-exercise-dialog-input-number inline-input"
              disabled={!selectedExercise}
              value={selectedExercise?.set}
              minFractionDigits={0}
              maxFractionDigits={0}
              onValueChange={(e: any) => handleDetailsChange(e.value, "set")}
              inputId="set"
              style={{ width: "3rem", borderRadius: "10px" }}
            />
            <span>{t("again")}</span>
            <InputNumber
              min={1}
              max={60}
              className="add-exercise-dialog-input-number inline-input"
              disabled
              value={selectedExercise?.restInterval}
              inputId="restInterval"
              style={{ width: "3rem", borderRadius: "10px" }}
            />
            <span>{t("hoursBreakWith")}</span>
            <InputNumber
              min={1}
              max={30}
              invalid={!!selectedExercise && selectedExercise?.repeat === null}
              className="add-exercise-dialog-input-number inline-input"
              disabled={!selectedExercise}
              value={selectedExercise?.repeat}
              minFractionDigits={0}
              maxFractionDigits={0}
              onValueChange={(e: any) => handleDetailsChange(e.value, "repeat")}
              inputId="repeat"
              style={{ width: "3rem", borderRadius: "10px" }}
            />
            <span>{t("repetitions")}.</span>
          </div>

          <div
            className="flex align-items-center gap-2"
            style={{ fontSize: "14px" }}
          >
            <InputNumber
              min={5}
              max={75}
              invalid={!!selectedExercise && selectedExercise?.tolerance === null}
              className="add-exercise-dialog-input-number inline-input"
              disabled={!selectedExercise}
              value={selectedExercise?.tolerance}
              onValueChange={(e: any) =>
                handleDetailsChange(e.value, "tolerance")
              }
              inputId="tolerance"
              minFractionDigits={0}
              maxFractionDigits={0}
              placeholder="%"
              suffix="%"
              style={{ width: "3.75rem", borderRadius: "10px" }}
            />
            <span>{t("tolerance")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExerciseEditSection;
